// *********************************
// CoolGames Builder JavaScript file
// *********************************
export var _version = "3.0.0";
console.log("%c%s", "color: Yellow; background: Red; font-size: 32px;", "Angry Birds " + _version);
